import {createGlobalStyle} from 'styled-components';
import {normalize} from 'styled-normalize';

// eslint-disable-next-line eag/no-css-property
const BasicStyles = createGlobalStyle`
  /* Unlayered CSS beats every Tailwind layer, so normalize goes below the platform utilities. */
  @layer base {
    ${normalize}
  }

  @media print {
    @page {
      margin: 10mm 0;
      size: 297mm 421mm;
    }

    @page:first {
      margin-top: 0;
    }
  }
`;

export const GlobalStyles = () => <BasicStyles />;
